import React, { useState, useEffect } from 'react';
import { PrimaryButton } from '../../../components';
import css from './ContactLinksForm.module.css';

function ContactLinksForm(props) {
  const {
    onSendCalendarLink,
    currentTransaction,
    hideTitle,
    closeEditForm,
  } = props;
  const [calendlyLink, setCalendlyLink] = useState(null);

  const handleSubmit = () => {
    return onSendCalendarLink(currentTransaction, calendlyLink)
      .then(resp => {
        if (closeEditForm) {
          return closeEditForm();
        }
      })
      .catch(e => console.log(e));
  };
  return (
    <div className={css.fieldsWrapper}>
      {!hideTitle && (
        <p className={css.title}>
          Please provide the following information to have your first meeting with your client
        </p>
      )}

      <strong>Calendar link</strong>
      <input
        value={calendlyLink}
        onChange={e => setCalendlyLink(e.target.value)}
        placeholder="Copy link here..."
      />

      <PrimaryButton
        className={css.submitButton}
        disabled={!calendlyLink}
        type="button"
        onClick={handleSubmit}
      >
        Submit
      </PrimaryButton>
    </div>
  );
}

export default ContactLinksForm;
